export default __webpack_public_path__ + "static/RGB_color_cube-8e102cb343ccfc6309e51ea0fb0c2637.svg";